var moduleMap = {
	"./EShopModule": () => {
		return Promise.all([__webpack_require__.e(1468), __webpack_require__.e(5912), __webpack_require__.e(6878), __webpack_require__.e(3091), __webpack_require__.e(8283), __webpack_require__.e(9205), __webpack_require__.e(7482), __webpack_require__.e(6653), __webpack_require__.e(2779), __webpack_require__.e(6632), __webpack_require__.e(92), __webpack_require__.e(2143), __webpack_require__.e(8632), __webpack_require__.e(6900)]).then(() => (() => ((__webpack_require__(46062)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});